import { CreateClientCmp } from '@/components/features/clients/CreateClientCmp'
import { NavHeader } from '../../components/features/shared/NavHeader'
import { PageContainer } from '@/components/features/shared/PageContainer'

export const CreateClientPage = () => {
  return (
    <PageContainer className='max-w-4xl '>
      <NavHeader>
        <h1 className="text-2xl font-bold tracking-tight">Nuevo Cliente</h1>
        <p className='text-muted-foreground'>Complete los datos solicitados para crear un nuevo cliente</p>
      </NavHeader>
      <CreateClientCmp />
    </PageContainer>
  )
}
